import axiosInstance from "@/lib/axiosInstance";
import { getQueryParamsWithCustomQueryObj } from "@/utils/getQueryParamsFromCustomQueryObject";
import type { TSearchParams } from "@/components/ui/Chips/FilterChip/types";
import { serviceProviderEndpoints } from "../serviceProvider.endpoints";

export const getServiceProviderDropDown = async (
  _type: string,
  search?: string,
  signal?: AbortSignal,
  key?: string,
  searchParams?: TSearchParams,
): Promise<any> => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  // field=firstName&field=lastName&field=id&type=ServiceProviderInformation&limit=10&modify={"source":["firstName","lastName"],"target":"value"}&distinct=true
  if (key === "name") {
    params.append("type", "ServiceProviderInformation");
    params.append("field", "firstName");
    params.append("field", "lastName");
    params.append("field", "id");
    params.append("limit", String(searchParams?.limit || 10));
    params.append("modify", encodeURI(`{"source":["firstName","lastName"],"target":"value"}`));
    params.append("distinct", "true");
    if (searchParams?.filterValueKey) {
      params.append("filterBy", searchParams.filterValueKey);
    }
    if (searchParams?.filterValue) {
      params.append("filterValue", searchParams.filterValue);
    }
  }

  // type=LookupTypes&field=label&field=id&filterBy=type&filterValue=provider_types&...
  if (key === "type") {
    params.append("type", "LookupTypes");
    params.append("field", "label");
    params.append("field", "id");
    params.append("filterBy", "type");
    params.append("filterValue", "provider_types");
    params.append("modify", encodeURI(`{"source":["label"],"target":"value"}`));
    params.append("distinct", "true");
    params.append("limit", String(searchParams?.limit || 10));
  }
  if (key === "providerType") {
    params.append("type", "LookupTypes");
    params.append("field", "label");
    params.append("field", "id");
    params.append("filterBy", "type");
    params.append("field", "value");
    params.append("filterValue", "provider_types");
    params.append("distinct", "true");
    params.append("limit", String(searchParams?.limit || 10));
  }

  // type=Trades&field=name&filterBy=parentTradeId&field=id&filterValue=null&...
  if (key === "trades") {
    params.append("type", "Trades");
    params.append("field", "name");
    params.append("field", "id");
    params.append("filterBy", "parentTradeId");
    params.append("filterValue", "null");
    params.append("modify", encodeURI(`{"source":["name"],"target":"value"}`));
    params.append("distinct", "true");
    params.append("limit", String(searchParams?.limit || 10));
  }
  //type=LookupTypes&field=label&field=id&filterBy=type&filterValue=current_profile_stage&search=a&limit=10&distinct=true&modify={"source": ["label"], "target":"value"}
  if (key == "stage") {
    params.append("type", "LookupTypes");
    params.append("field", "label");
    params.append("field", "id");
    params.append("filterBy", "type");
    params.append("filterValue", "current_profile_stage");
    params.append("limit", String(searchParams?.limit) || "10");
    params.append("distinct", "true");
    params.append("modify", encodeURI(`{"source": ["label"], "target":"value"}`));
  }

  // Status lookup: /dropdown/lookups?type=status&...
  if (key === "status") {
    params.append("type", "status");
    params.append("limit", String(searchParams?.limit || 10));
  }

  // Base URL comes from serviceProviderEndpoints.getProviderTypeDropdown (/dropdown?...)
  let url = serviceProviderEndpoints.getProviderTypeDropdown.split("?")[0];

  // Use dedicated service provider locations endpoint when filtering by location
  if (key === "location") {
    url = "/dropdown/service-provider-locations";
    params.append("limit", "20");
  }

  // W2 time-off status lookup: /dropdown/lookups?type=w2_timeoff_status
  if (key === "w2_timeoff_status") {
    params.append("type", "w2_timeoff_status");
    params.append("limit", String(searchParams?.limit || 10));
  }

  if (key === "service_provider_availability_status") {
    params.append("type", "service_provider_availability_status");
    params.append("limit", String(searchParams?.limit || 10));
  }

  if (
    key === "status" ||
    key === "w2_timeoff_status" ||
    key === "service_provider_availability_status"
  ) {
    url = "/dropdown/lookups";
  }

  const queryString = getQueryParamsWithCustomQueryObj(params);

  const response = await axiosInstance.get<any>(`${url}?${queryString}`, {
    signal,
  });

  return response.data;
};
